import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl } from 'react-bootstrap';

const Input = ({ horizontal, required, input, labelCol = 2, valueCol = 10, label, help, meta: { touched, error, warning }, length, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const values = input.value ? [...input.value] : Array(length).fill('');
	const itemOnChange = (index, value) => {
		values[index] = value;
		input.onChange(values);
	};

	const formControls = [...Array(length).keys()].map(index => <FormControl key={index} name={`${input.name}_${index}`}
		value={values[index]} type='text' placeholder={`${index + 1}.`}
		onChange={event => itemOnChange(index, event.target.value)} {...props} />);
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControls}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControls}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

Input.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	legth: PropTypes.number
};

export default Input;